import { UseMutationOptions } from "@tanstack/react-query";

import { useUpdatePinnedView as useUpdatePinnedViewBase } from "lib/hooks/api/pinned_views/useUpdatePinnedView";
import { EventDataTypes, EventNames, useTracking } from "lib/tracking";

type Props = { id: string; rank: number; name: string };

export function useUpdatePinnedView(
  options?: UseMutationOptions<unknown, unknown, Props, unknown>,
) {
  const { logEvent } = useTracking();
  const { mutate: updatePinnedView, ...rest } = useUpdatePinnedViewBase();

  const mutate = ({ id, rank, name }: Props) => {
    updatePinnedView(
      { input: { savedViewId: id, rank } },
      {
        onSuccess: (data, _vars, ctx) => {
          logEvent(EventNames.pinnedSavedViewRankChange, {
            "Saved view id": id,
            "Data type": EventDataTypes.notices,
            "Edit type": "Pinned View reordered",
            "Pinned View name": name,
          });
          options?.onSuccess?.(data, { id, rank, name }, ctx);
        },
        onError: (err, _vars, ctx) => {
          options?.onError?.(err, { id, rank, name }, ctx);
        },
      },
    );
  };

  return { mutate, ...rest };
}
